<template>
  <div id="app">
    <component :is="currentComponent"></component>
  </div>
</template>

<script>
import QuestionnaireContainer from './components/QuestionnaireContainer.vue'
import CheckoutContainer from './components/CheckoutContainer.vue'
import ThankYouContainer from './components/ThankYouContainer.vue'
const Dashboard = () => import('./components/Dashboard.vue')
const VendorRegistration = () => import('./components/vendor_registration/VendorRegistration.vue')
const RemoteLogin = () => import('src/components/authentication/RemoteLogin.vue')

export default {
  name: 'App',
  components: {
    QuestionnaireContainer,
    CheckoutContainer,
    ThankYouContainer
  },
  computed: {
    currentComponent() {
      document.title = "Symbium"

      if(!this.$route.matched[0]) {
        document.title = "Symbium"
        return Dashboard;
      }
      if (this.$route.matched[0].path == '/shop*') {
        document.title = "Shop | Symbium"
        if (this.$route.params.pathMatch == '/checkout') {
          return CheckoutContainer;
        } else if (this.$route.params.pathMatch == '/thank-you') {
          return ThankYouContainer;
        } else {
          return QuestionnaireContainer;
        }
      } else if(this.$route.matched[0].path == '/dashboard*') {
        document.title = "Dashboard | Symbium"
        return Dashboard;
      } else if (this.$route.matched[0].path == '/vendor_registration') {
        return VendorRegistration;
      } else if (this.$route.matched[0].path == '/remote_login') {
        return RemoteLogin;
      }

      document.title = "Dashboard | Symbium"
      return Dashboard;
    },
  },
}
</script>

<style lang='scss'>
  @import './assets/css/style.css';
  @import './assets/css/general.css';
  @import url($VUE_APP_ASSET + '/css/icon.min.css');
  @import url($VUE_APP_ASSET + '/css/general.min.css');
  @import url($VUE_APP_ASSET + '/widgets/widgets.min.css');
</style>
